import React from 'react';
import { LoaderSkeleton } from "../../components";
import { Card, Icon, List, Button, message, Spin, Row, Col} from 'antd';
import { APPLICANT_FIELDS_ASSOCIATE } from "constants/form-fields";
import PropTypes from "prop-types";
import { STATE_STATUS, UI_PERMISSIONS } from "constants";
import { PermissionContextManager } from "hocs";
import { SaveProxy, proxyWrapper } from "utilities/save-proxy";
import AddAssociateForm from "forms/add-associate-form";
import shortID from "uuid/v4";
import { AddressRecord, AssociateRecord } from '../../records';
import { Map } from 'immutable';
import { CompanyService } from '../../services';
import moment from 'moment';

const ListItem = List.Item;

const proxy = new SaveProxy();
const ProxiedButton = proxyWrapper(
    props => (
        <Button type="link" onClick={props.onClick} >
            {props.label}
        </Button>
    ),
    {
        count: false
    },
    proxy
);

class AssociatesNewForm extends React.Component {
    state = {
        associates : Map(),
        status: STATE_STATUS.UNFETCHED,
        loading: false
    }

    LABEL_LIST = () => {
        let APPLICANT_FIELDS_UPDATED = APPLICANT_FIELDS_ASSOCIATE;
        if(this.props.recreditViewOnlyPermission === true){
            APPLICANT_FIELDS_UPDATED = APPLICANT_FIELDS_ASSOCIATE?.filter((field,fieldName) => {
                return fieldName !== "remove";
            });
        }
        return(
            <List className={"f-grow-1 tabled-list tabled-list-header"} bordered>
                {APPLICANT_FIELDS_UPDATED?.map(_ => (
                    <ListItem className={"form-field-list-item"} key={_.placeholder} style={{display:"flex"}}>
                        {_.placeholder}
                    </ListItem>
                )).toList()}
            </List>
        );};
    baseID = shortID();
    formRefs =  this.props.associates && this.props.associates.size
        ? this.props.associates.map(() => React.createRef())
        : new Map({ [this.baseID]: React.createRef() });


    componentDidMount(){
        this.props.refreshAssociates()
        if(this.props.associate && this.props.associate.size){
            this.setState({
                associates: this.props.associate
            })
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.status == STATE_STATUS.FETCHING && this.props.status == STATE_STATUS.FETCHED){
            this.formRefs =  this.props.associates && this.props.associates.size
            ? this.props.associates.map(() => React.createRef())
            : new Map({ [this.baseID]: React.createRef() });    
            this.setState({
                associates: this.props.associates
            });
        }
    }

    componentWillUnmount(){
        this.setState({
            associates : Map(),
        })
    }

    isLoading = () => {
        return (
            [
                STATE_STATUS.UNFETCHED,
                STATE_STATUS.FETCHING,
                STATE_STATUS.UPDATING
            ].includes(this.state.status) || !this.state.status
        );
    };

    addAssociate = type => {
        const id = shortID();
        this.formRefs = this.formRefs.set(id, React.createRef());
        proxy.attach(id);
        this.setState({
            associates: this.state.associates.set(
                id,
                new AssociateRecord({
                    type,
                    is_active: true
                })
            ).setIn([id, 'company'] , this.props.companyId),
            associateCreatedFlag:true
        });
    };

    getCardActions = () =>
        this.props.ASSOCIATES_EDIT && this.props.isUserAllowedToEdit
            ?
             [
                <a
                    key="add-associate"
                    onClick={this.addAssociate.bind(null, 1)}
                    className="mr-5"
                    disabled={!this.props.ASSOCIATES_EDIT}
                >
                    {" "}
                    <Icon type={"plus"} /> Add Associate
                </a>,
                <a
                    key="add-guarantor"
                    onClick={this.addAssociate.bind(null, 2)}
                    className="mr-5"
                    disabled={!this.props.ASSOCIATES_EDIT}
                >
                    {" "}
                    <Icon type={"plus"} /> Add Guarantor
                </a>
            ]
            : [];

    proxiedButton = (
        <div className={"d-flex"}>
            <ProxiedButton
                key={"proxied-save-action"}
                onClick={() => this.saveAllAssociates()}
                label={"Save"}
            />
        </div>
    );

    formatDate(date){
        return moment(date).format('YYYY-MM-DD');
    }

    saveAllAssociates = () => {
        const errs = [];
        this.formRefs.map(_ =>
            _.current && _.current.validateFields(err => {
                if (err) {
                    errs.push(err);
                }
            })
        );
        const natureOfAssociationCounts = this.state.associates.reduce((count, el) => {
            if (el?.nature_of_association === 1) {
                return count + 1;
            }
            return count;
        }, 0);
        if (this.props.company.constitution == 1 && natureOfAssociationCounts > 1) {
            message.error("More than one applicant has a title of Propreitor");
            return;
        }
        if (errs.length === 0) {
            Promise.all(
                this.formRefs.map(
                    (_, associateID) =>
                        new Promise((resolve, reject) =>
                            _.current && _.current.validateFields(
                                (
                                    err,
                                    {
                                        name,
                                        residence_address,
                                        permanent_address,
                                        ...restValues
                                    }
                                ) => {
                                    if (!err) {
                                        this.setState({associateCreatedFlag :false});
                                        resolve(true);
                                    }
                                    reject();
                                }
                            )
                        )
                )
            )
                .then(() =>{
                   
                    let data = this.state.associates;
                    this.state.associates.map((currentAssociate , key) => {
                        ['city' , 'state', 'country' , 'district' , 'residing_since'].map(_ => {
                            if(typeof data.getIn([key, 'residence_address' , _]) == 'object' && ['country', 'district'].includes(_)){
                                data = data.setIn([key, 'residence_address' , _],data.getIn([key, 'residence_address' , _ , ['id']] , 1))
                            }
                            if(typeof data.getIn([key, 'permanent_address' , _]) == 'object' && ['country', 'district'].includes(_)){
                                data = data.setIn([key, 'permanent_address' , _],data.getIn([key, 'permanent_address' , _ , ['id']] , 1))
                            }

                            if(!['country', 'district' , 'residing_since'].includes(_)){ 
                                data = data.setIn([key, 'residence_address' , _],data.getIn([key, 'residence_address' , _ , ['id']]))
                                    .setIn([key, 'permanent_address' , _],data.getIn([key, 'permanent_address' , _ , ['id']]))
                            }

                            if(_ == 'residing_since'){
                                data = data.setIn([key, 'residence_address' , _] , moment(data.getIn([key, 'residence_address',_])).format('YYYY-MM-DD'))
                                .setIn([key, 'permanent_address' , _] , moment(data.getIn([key, 'permanent_address',_])).format('YYYY-MM-DD'))
                            }
                        })
                        data = data.setIn([key , 'dob'] ,this.formatDate(data.getIn([key , 'dob'])) )
                        .setIn([key , 'dob_pan'] ,this.formatDate(data.getIn([key , 'dob_pan'])))
                        .setIn([key , 'dob_aadhar'] ,this.formatDate(data.getIn([key , 'dob_aadhar'])))
                    })

                    const shareholdingSum = this.state.associates.toList().toJS().reduce((acc , object) =>  Number(acc) + Number(object.shareholding) , 0 )
                    let shareholdingCheck = this.props.company.constitution == 1 ? shareholdingSum == 100 : shareholdingSum >= 51 && shareholdingSum <= 100;
                    if(shareholdingCheck){
                        this.setState({
                            loading: true
                        })
                        CompanyService.updateCompanyAssociatesV2(data.toList() , this.props.caseId)
                        .then((resp) => {
                            this.setState({
                                loading: false
                            })
                            message.success('Updated Successfully')
                            this.props.refreshAssociates();
                        })
                        .catch((err) => {
                            this.setState({
                                loading: false
                            })
                            message.error('Something went wrong')
                        })
                    }else{
                        message.error(`Shareholding Sum must be ${this.props.company.constitution == 1 ? "100" : "51-100"}`)
                    }
                   
                })
                .catch(() => null);
        }
    };

    // parseError = (err) =>{
    //     let len = err.length;
    //     let message = ''
    //     for(let i=0; i<len ; i++){
    //         if(Object.keys(err[i]).length){
    //             let key1 = Object.keys(err[i])[0] ?  Object.keys(err[i])[0] : ''
    //             let key2 = '';
    //             if(Array.isArray(err[i][key1])){
    //                 key2 = err[i][key1] || ''
                    
    //             }else if(err[i][key1] && key1 != ''){
    //                 console.log('in elseee');
    //                 key2 = Object.keys(err[i][key1])[0] || ''
                    
    //             }
    //             message = message +  key1.split('_').join(' ').toUpperCase() +"  "+  key2 + " , "   
                
    //             }
    //         }
           
//     return 'Issue With ' +  message;
    // }


    getColorsLabel = () => {
        return <div className='ml-10'>
            <div className='align-items-center display-flex float-left ml-05'><div className="color_display" style={{background: "#2BB9F1E0"}}></div><span className="font_14">CKYC</span></div>
            <div className='align-items-center display-flex float-left ml-05'><div className="color_display" style={{background: "#34DB63C4"}}></div><span className="font_14">Digilocker</span></div>
            <div className='align-items-center display-flex float-left ml-05'><div className="color_display" style={{background: "#F1951EC4"}}></div><span className="font_14">PAN</span></div>
            <div className='align-items-center display-flex float-left ml-05'><div className="color_display" style={{background: "#191CF4C4"}}></div><span className="font_14">GSTIN</span></div>
        </div>
    }

    getCardExtra = () => 
        this.props.ASSOCIATES_EDIT && this.props.isUserAllowedToEdit && !this.props.recreditViewOnlyPermission ?
            [this.proxiedButton] 
            : [];

    sameAddressEventListener = (associateID, checked) => {
        if(checked){
            var finalData = this.state.associates;
            finalData = finalData.setIn([associateID , 'permanent_address'] , {});

            ['address_line_1', 'address_line_2', 'city', 'country' , 'district', 'is_communication_address', 'ownership_type', 'pincode', 'residing_since', 'state' , 'company' , 'associate'].map(_ => {
                finalData = finalData.setIn([associateID , 'permanent_address' , _] , this.state.associates.getIn([associateID , 'residence_address' , _]))
            })
            finalData = finalData.setIn([associateID , 'permanent_address' ,'address_type'] , 6);
            this.setState({
                associates : finalData
            })
        }else{
            finalData = this.state.associates.setIn([associateID , 'permanent_address'] , null);
            this.setState({
                associates : finalData
            })
        }
       
    }

    saveAssociate = (associateID, associateRecord, addressRecord, permanentAddressRecord) => {
    };



    deleteAssociateFromList = (associateID, associate) => {
        this.setState({
            associates: this.state.associates
                .setIn([associateID, "is_active"], false),
        }, () => {    
            this.props.update(
                this.props.companyId,
                this.state.associates.toList().toArray(),
                [],
                this.props.caseId,
                "delete",
                associate
            );
        });
    }

    deleteAssociate = associateID => {
        this.setState(
            {
                associates: this.state.associates.filter(
                    (_, associate) => associate !== associateID
                ),
                
            },
            () => proxy.detach(associateID)
        );
    };

    saveFormState = (associateID, changedValues) => {
        if(Object.keys(changedValues)[0] == 'permanent_address'){
            var finalData = Object.values(changedValues)[0];
            ['country' , 'is_communication_address', 'company' , 'associate'].map(_ => {
                finalData[_] = this.state.associates.getIn([associateID , 'residence_address' , _]);
            })
            finalData['id'] = null
            finalData['is_pv_done'] = false
            const data = new AddressRecord({...finalData , country : 1 , company: this.props.companyId, id: this.state.associates.getIn([associateID, 'permanent_address', 'id'], null)});
            this.setState({
                associates : this.state.associates.setIn([associateID , 'permanent_address'], data)
            })
        }else if(Object.keys(changedValues)[0] == 'residence_address'){
            const data = new AddressRecord({...Object.values(changedValues)[0] , country : 1 , company: this.props.companyId, id: this.state.associates.getIn([associateID, 'residence_address', 'id'], null)});
            this.setState({
                associates : this.state.associates.setIn([associateID , 'residence_address'], data)
            })
        }
        else{
            this.setState({
                associates : this.state.associates.setIn([associateID , Object.keys(changedValues)[0]], Object.values(changedValues)[0])
            })
        }
    };



    render(){
        let associateKeys = Object.keys(this.props.associates
            .filter(_ => _.is_active).toJS());
        return(
            <Spin spinning={this.state.loading}>
            <Card
                className={"padless-card"}
                title={<div className="display-flex align-items-center">Applicants {this.getColorsLabel()}</div>}
                extra={this.getCardExtra()}
                actions={this.getCardActions()}
            >
                <div className={"d-flex tabled-list-container"}>
                    {this.LABEL_LIST()}
                    { this.state.associates
                        .filter(_ => _.is_active)
                        .map((_, associateID) => {
                            return _ && this.props.company &&  <AddAssociateForm
                                company={this.props.company ? this.props.company : {}}
                                associateKeys={associateKeys}
                                sameAddressEventListener={this.sameAddressEventListener.bind(null,associateID)}
                                key={associateID}
                                showSpocOnly={this.props.showSpocOnly}
                                values={new AssociateRecord(_)}
                                associateID={associateID}
                                onFormSubmit={this.saveAssociate.bind(
                                    null,
                                    associateID
                                )}
                                deleteAssociate={this.deleteAssociate.bind(
                                    null,
                                    associateID
                                )}
                                deleteAssociateFromList={this.deleteAssociateFromList.bind(
                                    null,
                                    associateID,
                                    _
                                )}
                              
                                onValuesChange={this.saveFormState.bind(
                                    null,
                                    associateID
                                )}
                                ref={this.formRefs.get(associateID)}
                                editable={this.props.ASSOCIATES_EDIT}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                caseId={this.props.caseId}
                            />
                                })
                        .toList()}
                </div>
            </Card>
         </Spin>

        )
    }
}

AssociatesNewForm.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    associates: PropTypes.Map,
    addresses: PropTypes.object,
    company: PropTypes.object,
    status: PropTypes.string,
    update: PropTypes.func,
    showSpocOnly: PropTypes.bool,
    ASSOCIATES_EDIT: PropTypes.boolean,
    isUserAllowedToEdit: PropTypes.bool,
    openCaseApplicantModal: PropTypes.func,
    deleteAssociateStatus: PropTypes.string,
    recreditViewOnlyPermission: PropTypes.bool,
    companyNewAssociates: PropTypes.array
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.ASSOCIATES_VIEW,
    propsPermissions: {
        ASSOCIATES_EDIT: UI_PERMISSIONS.ASSOCIATES_EDIT
    }
})(AssociatesNewForm);